export default __webpack_public_path__ + "static/media/Table.2a1d53da.less";